import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { handleOAuthCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // Get session_id from URL hash fragment (format: #session_id=xxx or /#session_id=xxx)
    const hash = window.location.hash;
    const sessionIdMatch = hash.match(/session_id=([^&]+)/);
    const sessionId = sessionIdMatch ? sessionIdMatch[1] : null;
    
    console.log("[AuthCallback] Hash:", hash);
    console.log("[AuthCallback] Session ID found:", !!sessionId, "length:", sessionId?.length);
    
    if (sessionId) {
      handleOAuthCallback(sessionId)
        .then((user) => {
          console.log("[AuthCallback] Auth success for:", user.email);
          toast.success(`Welcome, ${user.name}!`);
          // Clear the hash from URL
          window.history.replaceState(null, '', '/');
          navigate("/", { replace: true });
        })
        .catch((error) => {
          console.error("[AuthCallback] Auth callback error:", error);
          console.error("[AuthCallback] Response status:", error.response?.status);
          console.error("[AuthCallback] Response data:", JSON.stringify(error.response?.data));
          toast.error("Authentication failed. Please try again.");
          window.history.replaceState(null, '', '/');
          navigate("/", { replace: true });
        });
    } else {
      console.warn("[AuthCallback] No session_id in URL hash:", window.location.href);
      navigate("/", { replace: true });
    }
  }, []);

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto mb-4 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-zinc-400">Completing sign in...</p>
      </div>
    </div>
  );
}
